var _Circle, _Path, _Path2, _Path3, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M5.543 12.695c.08-.08.19-.126.306-.126h10.534c.193 0 .29.233.153.369l-2.081 2.08a.432.432 0 0 1-.305.127H3.615a.216.216 0 0 1-.153-.368l2.081-2.082Z",
    fill: "url(#paint0_linear_3827_2152)"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M5.545 4.926a.444.444 0 0 1 .306-.126h10.534c.193 0 .29.232.153.368L14.457 7.25a.432.432 0 0 1-.305.126H3.617a.216.216 0 0 1-.153-.368l2.081-2.081Z",
    fill: "url(#paint1_linear_3827_2152)"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M14.455 8.786a.432.432 0 0 0-.305-.126H3.615a.216.216 0 0 0-.153.368l2.081 2.081c.08.08.19.126.306.126h10.534a.216.216 0 0 0 .153-.368l-2.081-2.081Z",
    fill: "url(#paint2_linear_3827_2152)"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_3827_2152",
    x1: 15.377,
    y1: 3.556,
    x2: 8.086,
    y2: 17.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_3827_2152",
    x1: 12.191,
    y1: 1.892,
    x2: 4.9,
    y2: 15.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_3827_2152",
    x1: 13.773,
    y1: 2.719,
    x2: 6.482,
    y2: 16.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
};
export default SvgSol;